import { ConquestPrivateIncentiveAddress } from '../../../types/essential-ui/ConquestPrivateIncentiveAddress';
import { ContractData } from '../../../types/essential-ui/ContractData';
import { DealSheet, mvoDealsheetlist } from '../../../types/essential-ui/DealSheet';
import { PrivateOffer } from '../../../types/essential-ui/PrivateOffer';
import { BuildPathFromParameters } from '../../api/ApiMethods';
import { GetOneFromPath } from '../../api/GenericClient';

const initialPath = '/euidealsheet';
const mvoInitialpath = '/common/GetRecommendedReplacementVehicles';
const rebateCategories = '/dealsheet/rebateCategories';
const contract = '/dealsheet/contract';

async function getEUIDealsheet(
  id: string,
  dealerId: string,
  userId: string,
  userName: string,
): Promise<DealSheet> {
  const closedDealId = id;
  const data = {
    dealerId: dealerId,
    closedDealId: closedDealId,
    userName: userName,
  };
  const path = BuildPathFromParameters(initialPath, data);
  return await GetOneFromPath<DealSheet>(path);
}

async function getEUIDealsheetMvo(
  id: string,
  dealerId: string,
  userName: string,
  rank: string,
): Promise<DealSheet> {
  const closedDealId = id;
  const data = {
    dealerId: dealerId,
    closedDealId: closedDealId,
    userName: userName,
    rank: rank,
  };
  const path = BuildPathFromParameters(initialPath, data);
  return await GetOneFromPath<DealSheet>(path);
}

async function getEUIDealsheetMvoList(id: string, dealerId: string): Promise<mvoDealsheetlist[]> {
  const closedDealId = id;
  const data = { closedDealId: closedDealId, dealerId: dealerId };
  const path = BuildPathFromParameters(mvoInitialpath, data);
  return await GetOneFromPath<mvoDealsheetlist[]>(path);
}

async function getRebateCategories(brandCode: string): Promise<any> {
  const data = { brandCode: brandCode };
  const path = BuildPathFromParameters(rebateCategories, data);
  return await GetOneFromPath<any>(path);
}

export const getConquestPrivateIncetiveAddresses = async (
  lastName: string,
  zipCode: string,
): Promise<ConquestPrivateIncentiveAddress[]> => {
  const method = '/eui/common/conquestPrivateIncentiveAddresses';
  const data = { lastName, zipCode };
  const path = BuildPathFromParameters(method, data);
  return GetOneFromPath<ConquestPrivateIncentiveAddress[]>(path);
};

export const getPrivateIncentive = async (
  closedDealId: string,
  dealerId: string,
  privateIncentiveActionType: string,
): Promise<PrivateOffer> => {
  const method = '/dealsheet/GetPrivateOfferAsync';
  const data = { closedDealId, dealerId, privateIncentiveActionType };
  const path = BuildPathFromParameters(method, data);
  return GetOneFromPath<PrivateOffer>(path);
};

export const getPrivateIncentiveLookup = async (
  lastName: string,
  vin: string,
  brandsList: string[],
): Promise<PrivateOffer[]> => {
  const brands = brandsList.join('&brands=');
  const method = '/eui/common/GetDataForPrivateIncentiveLookUp';
  const data = { lastName, vin, brands };
  const path = BuildPathFromParameters(method, data);
  return GetOneFromPath<PrivateOffer[]>(path);
};

async function getContract(id: string, dealerId: string, chromeId: string): Promise<ContractData> {
  const data = { id: id, dealerId: dealerId, chromeId: chromeId };
  const path = BuildPathFromParameters(contract, data);
  return await GetOneFromPath<ContractData>(path);
}

export const EUIDealsheetService = {
  getEUIDealsheet,
  getEUIDealsheetMvo,
  getEUIDealsheetMvoList,
  getRebateCategories,
  getConquestPrivateIncetiveAddresses,
  getPrivateIncentive,
  getPrivateIncentiveLookup,
  getContract,
};
